import localforage from 'localforage';

const menuStore = localforage.createInstance({
  name: 'TakeawayPOS',
  storeName: 'menu_sync',
});

export default menuStore;
